import React, { useState } from "react"
import DeleteModal from "../../../components/Common/DeleteModal"
import { usePagination } from "../../../hooks/usePagination"
import ResultHandler from "../../../components/ResultHandler"
import PaginationHandler from "../../../components/PaginationHandler"
import TableHeaderHandler from "../../../components/TableHeaderHandler"
import { useTranslation } from "react-i18next"
import { useResponse } from "../../../hooks/useResponse"
import TableAction from "../../../components/TableAction"
import EmptyData from "../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../api/permissions";
import { getPriceComponents, deletePriceComponent, getRelatedPriceComponents, deassignPriceComponent } from "../../../api/priceComponent"
import { useParams } from "react-router-dom"
import AssignPriceComponentsModal from "./AssignPriceComponentsModal"
import { Button } from "reactstrap"
import { formatCurrency } from "../../../utils/formatCurrency"



export default function RelatedPriceComponentsTable({hideTableAction, hideTableHeader, relatedId, type}) {

  const { t } = useTranslation()

  const API_META = {id: relatedId, type}
  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,

  } = usePagination(getRelatedPriceComponents, API_META)

  //// delete 
  const [show, setShow] = useState(false)

  function onCloseClick() {
    setShow(false)
  }

  const [deletingPriceComponent, setDeletingPriceComponent] = useState(null)

  const { setData } = useResponse(deassignPriceComponent, () => {
    setShow(false)
    setDeletingPriceComponent(null)
    setPayload({...API_META, ref: true})
  })

  function onDeleteClick() {
    setData({ type: "add", data: {id: deletingPriceComponent}})
  }


  //////// assign

  const [assignOpen, setAssignOpen] = useState(false)


  return (
    <>
   
      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>Name</Th>
                <Th>Amount</Th>
                <Th>Admin</Th>

                {!hideTableAction && <Th className="text-center" style={{ width: "15%" }}>{t("tables.Action")}</Th>}
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.priceComponents.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>{row.priceComponent.name}</Td>
                      <Td>{row.priceComponent.amount_type == 'percentage' ? row.amount + "%" : formatCurrency(row.amount)}</Td>
                      <Td>{row.admin?.username}</Td>

                      {!hideTableAction && <Td className="text-center">
                        <TableAction
                          //hasEdit={true}
                          hasDelete={true}
                          editPermission={PERMISSIONS.PRICE_COMPONENT_EDIT}
                          deletePermission={PERMISSIONS.PRICE_COMPONENT_DELETE}
                          type="price-component"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingPriceComponent}
                        />
                      </Td>}
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

         

          {!loading &&
            <EmptyData empty={response.data && response.data.priceComponents.length === 0} msg="No Price Components Found." />
          }

          <div className="d-flex" style={{justifyContent: "flex-end", marginTop: "20px"}}>
            <Button color="dark" onClick={() => setAssignOpen(true)}>Add</Button>
          </div>

          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {assignOpen && <AssignPriceComponentsModal 
            relatedId={relatedId}
            show={assignOpen}
            handleClose={() => setAssignOpen(false)}
            type={type}
            handleRefetch={() => {
              setPayload({...API_META, ref: true})
            }}
          />}

          <ResultHandler error={error} loading={loading} />

        </div>
      </div>
    </>
  )
}
